export default async function format(value, options) {
  let formattedValue = value;

  formattedValue = `${options.urlPrefix}${value}`;

  return formattedValue;
}
